import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'WASH_ADMIN_DEVICE_DETAIL',
        create: 'WASH_ADMIN_DEVICE_CREATE',
        update: 'WASH_ADMIN_DEVICE_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'admin_user_id',
        default: '',
        label: '管理员编号',
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "admin_user_id",
              "custom": true,
              "stringify": true
            },
            "model": {
              value: _this.form.model.admin_user_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "admin_user_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_id',
        default: '',
        label: '设备编号',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.device_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "device_id", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'admin_user_id',
        method: this.$api.WASH_ADMIN_ALL,
        fields: 'admin_user_id,admin_user_name',
        path: 'list',
        label: 'admin_user_name',
        value: 'admin_user_id'
      });
    }
  }
};